import { useState, useEffect } from 'react'
import { supabaseHelpers } from '../lib/supabase'

export const useSegnalazioni = (userId = null, isAdmin = false) => {
  const [segnalazioni, setSegnalazioni] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const fetchSegnalazioni = async () => {
    setLoading(true)
    setError(null)
    
    try {
      let result
      if (isAdmin) {
        result = await supabaseHelpers.getAllSegnalazioni()
      } else if (userId) {
        result = await supabaseHelpers.getSegnalazioniByUser(userId)
      } else {
        result = { data: [], error: null }
      }

      if (result.error) {
        setError(result.error.message)
      } else {
        setSegnalazioni(result.data || [])
      }
    } catch (err) {
      setError(err.message)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (userId || isAdmin) {
      fetchSegnalazioni()
    } else {
      setLoading(false)
    }
  }, [userId, isAdmin])

  const createSegnalazione = async (segnalazioneData) => {
    try {
      const dataWithId = {
        ...segnalazioneData,
        id: crypto.randomUUID(),
        created_at: new Date().toISOString()
      }
      
      const { data, error } = await supabaseHelpers.createSegnalazione(dataWithId)
      if (error) throw error
      
      await fetchSegnalazioni() // Refresh the list
      return { data, error: null }
    } catch (err) {
      return { data: null, error: err }
    }
  }

  const updateSegnalazione = async (segnalazioneId, updates) => {
    try {
      const { data, error } = await supabaseHelpers.updateSegnalazione(segnalazioneId, updates)
      if (error) throw error
      
      await fetchSegnalazioni() // Refresh the list
      return { data, error: null }
    } catch (err) {
      return { data: null, error: err }
    }
  }

  const deleteSegnalazione = async (segnalazioneId) => {
    try {
      const { error } = await supabaseHelpers.deleteSegnalazione(segnalazioneId)
      if (error) throw error
      
      await fetchSegnalazioni() // Refresh the list
      return { error: null }
    } catch (err) {
      return { error: err }
    }
  }

  return {
    segnalazioni,
    loading,
    error,
    createSegnalazione,
    updateSegnalazione,
    deleteSegnalazione,
    refetch: fetchSegnalazioni
  }
}